import React from 'react';
import PropTypes from 'prop-types';
import StringInput from '../../../BaseEditor/stringInput';
import { tablePropType } from '../hooks';
import { ListItem } from '../styles';

function SettingItem({
  setting, active, onRenameSetting, onClick,
}) {
  return (
    <ListItem
      key={setting.key}
      active={active}
      style={{ marginTop: '4px' }}
      onClick={onClick}
    >
      <StringInput
        controlId={`input-table-${setting.key}`}
        value={setting.name}
        readOnly={setting.name === 'main'}
        onChange={(e, v) => onRenameSetting(setting.name, v)}
        noBackground
      />
    </ListItem>
  );
}

SettingItem.propTypes = {
  setting: tablePropType.isRequired,
  active: PropTypes.bool,
  onRenameSetting: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

SettingItem.defaultProps = {
  active: false,
};

export default SettingItem;
